import { render } from "./TrocaUsuario.vue?vue&type=template&id=ef7399c2&scoped=true"
import script from "./TrocaUsuario.vue?vue&type=script&lang=js"
export * from "./TrocaUsuario.vue?vue&type=script&lang=js"

import "./TrocaUsuario.vue?vue&type=style&index=0&id=ef7399c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7399c2"]])

export default __exports__